/* src/app/front-layout/rapid-course/rapid-course.component.css */
.spacer {
  height: 100px;
}
.hdings {
  font-size: 40px;
  color: black;
  font-weight: 600;
}
.content-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
}
.content-sub {
  width: 100%;
  display: flex;
  gap: 10px;
  padding-left: 20px;
  padding-right: 20px;
}
.c-sec-left {
  width: 70%;
  height: 100%;
  display: flex;
}
.lm-space {
  font-size: 18px;
  color: #007BA7;
  font-weight: 600;
}
.bg-dv {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
}
.bg-dv p {
  margin-top: 25px;
  text-align: justify;
}
.bg-dv h1 {
  font-size: 40px;
  font-weight: bold;
  color: #007BA7;
}
.c-sec-right {
  width: 40%;
  border-radius: 20px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
}
.cs-right-sub {
  width: 100%;
  padding: 20px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
}
.cs-right-sub img {
  height: 200px;
  object-fit: cover;
  border-radius: 20px;
}
.cont-price {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tag-online {
  width: 150px;
  background-color: #4CAF50;
  color: #fff;
  padding: 10px 20px;
  border-radius: 30px;
  border: none;
}
.course-ft-list {
  margin-top: 20px;
}
.course-ft {
  font-size: 20px;
  margin: 20px;
}
.course-ft img {
  width: 25px;
  height: 25px;
}
.button-cont {
  margin-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.book-btn {
  padding: 15px;
  width: 90%;
  align-self: center;
  background-color: #007BA7;
  border-radius: 30px;
  border: none;
  font-size: 18px;
  color: white;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 10px;
}
.strike-container {
  position: relative;
  display: inline-block;
  font-size: 20px;
}
.strike-price {
  position: relative;
  color: #070707;
  font-weight: bold;
}
.strike-price::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: red;
  transform: translateY(-50%);
}
.ss-timing {
  padding-left: 50px;
  padding-right: 50px;
  margin-top: 50px;
}
.st-cont {
  display: flex;
  align-items: center;
  gap: 100px;
  padding-left: 25px;
  padding-right: 25px;
  align-self: center;
  margin-top: 25px;
}
.st-li {
  font-size: 18px;
}
.st-li img {
  width: 25px;
  height: 25px;
}
.st-cont p {
  margin: 0px;
  font-size: 22px;
}
.st-card {
  width: 250px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
}
.ab-ss {
  padding-left: 50px;
  padding-right: 50px;
  margin-top: 50px;
}
.ab-ss p {
  font-size: 16px;
}
.pricing-cont {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  padding-left: 50px;
  padding-right: 50px;
}
.ps-cont {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1);
  margin: 40px auto;
  overflow: hidden;
}
.ps-cards {
  display: flex;
  gap: 20px;
  flex-direction: row;
  flex-wrap: wrap;
}
.ps-card {
  background-color: #f2f2f2;
  padding: 30px 40px;
  border-radius: 20px;
  text-align: center;
  min-width: 180px;
  margin: 20px;
}
.card h2 {
  font-size: 36px;
  margin: 0 0 10px;
  font-weight: bold;
}
.title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}
.subtext {
  font-size: 14px;
  color: #555;
  margin-top: 8px;
}
.image-section img {
  max-width: 350px;
  height: auto;
  border-radius: 0 20px 20px 0;
  object-fit: cover;
}
.course-cont {
  display: flex;
  flex-direction: column;
  padding-left: 50px;
  padding-right: 50px;
  margin-top: 50px;
}
.course-cont h1 {
  margin-bottom: 50px;
}
.course-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 40px;
}
.course-left {
  flex: 1;
  min-width: 300px;
}
.course-left h1 {
  margin-bottom: 20px;
}
.class-box {
  background-color: #f5f5f5;
  padding: 15px 20px;
  border-radius: 12px;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  max-width: 500px;
}
.note {
  font-weight: 600;
  font-size: 15px;
}
.course-right {
  display: flex;
  align-items: center;
  justify-content: center;
}
.course-right img {
  max-width: 500px;
  width: 100%;
  height: auto;
  border-radius: 12px;
  object-fit: cover;
}
.exam-sec {
  margin-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
}
.offer-container {
  display: flex;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  max-width: 1200px;
  margin: 2rem auto;
  align-items: center;
}
.text-section {
  flex: 1.5;
  padding: 2rem;
}
.text-section h2 {
  font-size: 24px;
  margin-bottom: 0;
}
.text-section p {
  margin-bottom: 1.5rem;
  font-size: 18px;
}
.text-section strong {
  display: block;
  margin: 1rem 0 1.5rem;
  font-size: 18px;
}
.image-section {
  flex: 0.65;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-section img {
  width: 100%;
  height: 400px;
  object-fit: cover;
}
.asm-cont {
  margin-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
}
.analysis-container {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 2rem auto;
  max-width: 1200px;
}
.image-side {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
}
.image-side img {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.text-side {
  flex: 1.5;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.card {
  background-color: #fafafa;
  border-radius: 16px;
  padding: 1.5rem;
  font-size: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.ptm-section {
  margin-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
  margin-bottom: 25px;
}
.ptm-section h1 {
  margin-bottom: 50px;
}
.ptm-container {
  display: flex;
  align-items: center;
  background-color: #f8f8f8;
  border-radius: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  max-width: 1200px;
  margin: auto;
}
.ptm-content {
  flex: 1;
  padding: 30px;
  font-size: 20px;
  color: #000;
}
.ptm-content .highlight {
  font-weight: 600;
  color: #007BA7;
}
.ptm-image img {
  max-width: 450px;
  height: auto;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  display: block;
}
.tet-section {
  margin-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
  display: flex;
  flex-direction: column;
}
.tet-section h1 {
  margin-bottom: 50px;
}
.effort-time-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  max-width: 1200px;
  margin: auto;
  gap: 40px;
}
.effort-left {
  flex: 1;
  text-align: center;
}
.effort-left h2 {
  font-size: 24px;
  margin-bottom: 20px;
}
.effort-left img {
  max-width: 100%;
  height: auto;
}
.effort-right {
  flex: 1;
  background-color: #f8f8f8;
  border-radius: 24px;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.effort-box {
  background-color: #eaeaea;
  padding: 16px 20px;
  border-radius: 16px;
  font-size: 18px;
  font-weight: 500;
}
.last-sec {
  margin-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
}
.last-sec h1 {
  margin-bottom: 50px;
}
.course-info-section {
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
}
.section-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 24px;
}
.info-container {
  display: flex;
  align-items: center;
  background-color: #f6f6f6;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.info-content {
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 40px;
}
.learn-more-button {
  width: 300px;
  background-color: #007BA7;
  color: white;
  font-size: 18px;
  padding: 16px 36px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.learn-more-button:hover {
  background-color: #d25416;
}
.info-image {
  flex: 1;
}
.info-image img {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
@media (max-width: 768px) {
  .spacer {
    height: 60px;
  }
  .content-sub {
    flex-direction: column;
    padding: 0 10px;
  }
  .c-sec-left,
  .c-sec-right {
    width: 100% !important;
  }
  .bg-dv h1 {
    font-size: 28px !important;
    line-height: 1.2;
  }
  .bg-dv p {
    font-size: 16px;
    display: none;
  }
  .c-sec-right {
    margin-top: 30px;
  }
  .course-ft {
    font-size: 16px !important;
    margin: 10px 0 !important;
  }
  .st-cont {
    flex-direction: column;
    gap: 20px;
    padding: 0 10px;
  }
  .st-card {
    width: 100%;
    max-width: 300px;
  }
  .hdings {
    font-size: 28px !important;
    text-align: center;
    padding: 0 15px;
  }
  .pricing-cont {
    padding: 20px;
  }
  .ps-cont {
    flex-direction: column-reverse;
  }
  .ps-cards {
    flex-direction: column;
    align-items: center;
  }
  .ps-card {
    width: 100%;
    margin: 10px 0;
  }
  .image-section img {
    width: 100%;
    border-radius: 0;
  }
  .course-cont {
    padding: 20px;
  }
  .course-container {
    flex-direction: column;
  }
  .course-right img {
    margin-top: 20px;
  }
  .exam-sec {
    padding: 20px;
  }
  .offer-container {
    flex-direction: column;
  }
  .text-section h2 {
    font-size: 20px;
  }
  .text-section p {
    font-size: 16px;
  }
  .image-section {
    width: 100%;
  }
  .image-section img {
    object-fit: cover;
    border-radius: 20;
    width: 100%;
  }
  .asm-cont {
    padding: 20px;
  }
  .analysis-container {
    flex-direction: column;
  }
  .image-side img {
    border-radius: 0;
  }
  .ptm-section {
    padding: 20px;
  }
  .ptm-container {
    flex-direction: column;
  }
  .ptm-image img {
    width: 100%;
  }
  .tet-section {
    padding: 20px;
  }
  .effort-time-container {
    flex-direction: column;
  }
  .last-sec {
    padding: 20px;
  }
  .info-container {
    align-items: stretch;
    flex-direction: column;
  }
  .book-btn {
    width: 100%;
  }
  .button-cont {
    text-align: center;
  }
  .class-box {
    max-width: 100%;
    font-size: 15px;
    padding: 12px 15px;
  }
  .cont-price {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  .tag-online {
    margin-top: 10px;
  }
  .course-ft-list {
    padding-left: 0;
  }
}
@media (max-width: 480px) {
  .bg-dv h1 {
    font-size: 24px !important;
  }
  .hdings {
    font-size: 24px !important;
  }
  .cont-price h2 {
    font-size: 24px;
  }
  .ps-card h2 {
    font-size: 28px;
  }
  .class-box {
    font-size: 14px;
  }
}
/*# sourceMappingURL=rapid-course.component.css.map */
